<template>
    <div>
        <label class="house-checkbox" :class="{'active': isChecked}">
            <!-- <img v-show="isChecked" :src="checkedImg" alt=""> -->
            {{checkboxMsg}}
            <input type="checkbox" :value="isChecked" v-model="checked" @change="onChange" />
        </label>
    </div>
</template>
<script>
export default {
    name: 'houseCheckbox',
    data () {
        return {
            isChecked: this.isPropChecked,
        }
    },
    props: {
        checkboxMsg: String,
        val: '',
        value: '',
        isPropChecked: {
            default: true,
            type: Boolean
        },
        setDefault: Boolean
    },
    watch: {
        isPropChecked: {
            handler: function (newValue, oldValue) {
                console.log(newValue)
                this.isChecked = newValue
            },
            immediate: true
        },
        setDefault: function () {
            if(this.setDefault){
                this.isChecked = this.setDefault
            }
        }
    },
    computed: {
        checked: {
            get () {
                return this.value
            },
            set (value) {
                let data = {
                    value: !this.isChecked,
                    name: this.checkboxMsg
                }
                this.checkVal = data
            }
        }
    },
    methods: {
        onChange: function(e) {
            this.isChecked = !this.isChecked;
            this.$emit('input', this.checkVal)
        },
    }
}
</script>
<style lang="scss" scoped>
    .house-checkbox{
        position: relative;
        font-size: 14px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 12px;
        width: 104px;
        height: 44px;
        border-radius: 4px;
        color: #a8a5a4;
        border: solid 1px #cacfcd;
        background-color: #ffffff;
        cursor: pointer;
        input{
            display: none;
        }
    }
    .house-checkbox.active{
        border: solid 1px #ff9275;
        color: #ff9275;
    }
</style>


// WEBPACK FOOTER //
// src/components/widge/HouseCheckbox.vue